import { render, staticRenderFns } from "./XColorPicker.vue?vue&type=template&id=13adbf4d"
import script from "./XColorPicker.vue?vue&type=script&lang=js"
export * from "./XColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports